module.exports = __webpack_public_path__ + "static/media/039-woman-10.322ff8d9.svg";